import React, {useEffect, useRef, useState} from 'react';
import {X} from 'lucide-react';
import ParticipationDetails, {date,labels,name} from './ParticipationDetails';

export default function ExecutionHistory({chainId,onClose}) {
  const dialog = useRef(null);
  const [selected,setSelected] = useState(null);
  const [before,setBefore] = useState(null);
  const [data,setData] = useState(null);
  const [error,setError] = useState('');
  const [reload,setReload] = useState(0);
  const [player,setPlayer] = useState('');
  const [state,setState] = useState('');
  const [filters,setFilters] = useState({player:'',state:''});
  useEffect(() => {
    const previous = document.activeElement;
    dialog.current.showModal();
    return () => previous?.focus();
  },[]);
  useEffect(() => {
    let request;
    let active = true;
    const refresh = async () => {
      request?.abort(); const current = new AbortController(); request = current;
      try {
        const params=new URLSearchParams();
        if (before) params.set('before',before);
        if (filters.player) params.set('player_id',filters.player);
        if (filters.state) params.set('state',filters.state);
        const url = selected ? `/automation-chains/${chainId}/execution?execution_id=${selected}` : `/automation-chains/${chainId}/executions?${params}`;
        const response = await fetch(url,{headers:{Accept:'application/json'},signal:current.signal});
        if (!response.ok) throw new Error('Could not load participants. Try again.');
        const result = await response.json();
        if (!active || current.signal.aborted) return;
        setData(result); setError('');
      } catch (err) { if (active && err.name !== 'AbortError') setError(err.message); }
    };
    refresh(); const interval = setInterval(refresh,3000);
    return () => { active = false; clearInterval(interval); request?.abort(); };
  },[chainId,selected,before,reload,filters]);
  const show = (id) => {setData(null);setSelected(id);};
  return <dialog ref={dialog} className='automation-chains-dialog chain-executions-dialog' aria-labelledby='execution-history-title'
    onCancel={(event) => {event.preventDefault();onClose();}}>
    <header><h2 id='execution-history-title'>{selected ? `Player ${data?.player_id || '…'}` : 'Participants'}</h2>
      <button className='chain-button chain-button--ghost' aria-label='Close participants' onClick={onClose}><X size={16} strokeWidth={1.6} /></button></header>
    <p className='chain-help'>Times are UTC. Updates every 3 seconds.</p>
    {!selected && <form className='chain-participant-filters' onSubmit={(event)=>{event.preventDefault();setBefore(null);setData(null);setFilters({player:player.trim(),state});}}>
      <label>Player ID<input aria-label='Player ID' value={player} maxLength={255} onChange={(event)=>setPlayer(event.target.value)} /></label>
      <label>Participation status<select value={state} onChange={(event)=>setState(event.target.value)}>
        <option value=''>All statuses</option><option value='inside'>Inside chain</option>
        {['waiting','processing','sending','completed','exited','filtered_out','failed','stopped'].map((value)=><option key={value} value={value}>{labels[value]}</option>)}
      </select></label><button className='chain-button' type='submit'>Search</button>
    </form>}
    {error && <p role='alert' className='chain-error'>{error} <button className='chain-button' onClick={() => setReload((value) => value+1)}>Retry</button></p>}
    {!data && !error && <p role='status'>Loading participants…</p>}
    {selected && data && <>
      <ParticipationDetails data={data} />
    </>}
    {!selected && data && <>
      <div className='chain-table-wrap'><table className='chain-table'><thead><tr><th>Entry</th><th>Player ID</th><th>Status</th><th>Current / last step</th><th>Entered (UTC)</th><th>Due (UTC)</th><th>Finished (UTC)</th></tr></thead>
        <tbody>{data.executions.map((entry) => <tr key={entry.id}><td>#{entry.id}</td><td><button className='chain-link' onClick={() => show(entry.id)}>{entry.player_id}</button></td>
          <td>{labels[entry.status]}</td><td>{name(entry.current_node)}</td><td className='chain-date'>{date(entry.entered_at)}</td><td className='chain-date'>{date(entry.due_at)}</td><td className='chain-date'>{date(entry.completed_at)}</td></tr>)}</tbody>
      </table></div>
      {!data.executions.length && <p className='chain-help'>{filters.player || filters.state ? 'No participants match the filters.' : 'No participants yet.'}</p>}
      {data.next_cursor && <button className='chain-button' onClick={() => {setBefore(data.next_cursor);setData(null);}}>Older participants</button>}
    </>}
    <footer>{selected && <button className='chain-button' onClick={() => show(null)}>Back to participants</button>}
      {selected && <a className='chain-button' href={`/automation-chains/${chainId}/execution?execution_id=${selected}`}>Open full history</a>}
      {!selected && before && <button className='chain-button' onClick={() => {setBefore(null);setData(null);}}>Latest participants</button>}
      <button className='chain-button' onClick={onClose}>Close</button></footer>
  </dialog>;
}
